// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3FORW","form":"styles_form__12GlJ","formTitle":"styles_formTitle__6-rfa","formButtons":"styles_formButtons__Q0FxL"};